import React from 'react'
import Head from 'next/head'
import Link from 'next/link'
import Hero from '../components/Hero'
import Menu from '../components/Menu'
import Block from '../components/Block'
import { NextSeo } from 'next-seo';
import schedule from '../data/schedule.yml'
import Talk from '../components/Talk'
import Footer from '../components/Footer'
import PatronTalk from '../components/PatronTalk'
import RegistrationButton from '../components/RegistrationButton'

const Schedule = props =>
  <div id="main-container">
    <NextSeo
      title='スケジュール | PyCon mini Hiroshima 2020'
      description='PyCon mini Hiroshima 2020 のスケジュールです。'
      openGraph={{
        title: 'スケジュール | PyCon mini Hiroshima 2020',
        description: 'PyCon mini Hiroshima 2020 のスケジュールです。'
      }}
    />

    <header>
      <Menu />
    </header>

    <div role='main'>
      <RegistrationButton />
      <div>
        <h1 className='block'>PyCon mini Hiroshima 2020 スケジュール</h1>
      </div>
      
      <Block>
        <div className='general-info'>
          <h2>2020年10月10日(土曜) オンライン開催</h2>
        </div>
      </Block>
      
      <Block title='' backgroundClass='not-center'>
        {schedule.map(
          item =>
            <div className={'schedule-item ' + item.type}>
              <div className='schedule-time'>
                <span className='schedule-time-begin'>{item.begin}</span>
                <span className='schedule-time-end'>{item.end}</span>
              </div>
              <div className='bar'/>
              {item.type == 'talk' && <Talk talkId={item.talk}/>}
              {item.type == 'keynote' && <Talk talkId={item.talk}/>}
              {item.type == 'patrontalk' && <PatronTalk talkId={item.talk}/>}
              {item.type == 'break' && item.name}
            </div>
           )
        }
      </Block>

    </div>

    <Footer/>
  </div>

Schedule.getInitialProps = async function() {
};

export default Schedule;
